import axios from "axios";

const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}`;

export const getActiveBrand = async (param) => {
  const { data } = await axios.get(`${baseUrl}/admin/brand/categories`);
  return data;
};
export const createBrandContent = async (param) => {
  const { data } = await axios.post(`${baseUrl}/admin/brand/contents`, param);
  return data;
};

export const deleteBrandContent = async (id) => {
  const { data } = await axios.delete(`${baseUrl}/admin/brand/contents/${id}`);
  return data;
};

export const getBrandContentsByType = async (param) => {
  const { data } = await axios.get(`${baseUrl}/admin/brand/contents-by-type`, {
    params: param,
  });
  return data;
};
